/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiModelsEnumerationTypesEmailNotificationPreference = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiModelsEnumerationTypesEmailNotificationPreference = typeof WebApiModelsEnumerationTypesEmailNotificationPreference[keyof typeof WebApiModelsEnumerationTypesEmailNotificationPreference];


export function WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON(json: any): WebApiModelsEnumerationTypesEmailNotificationPreference {
    return WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesEmailNotificationPreference {
    return json as WebApiModelsEnumerationTypesEmailNotificationPreference;
}

export function WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON(value?: WebApiModelsEnumerationTypesEmailNotificationPreference | null): any {
    return value as any;
}

